import { awaitJSON, DigitalAuditLambdaFetch } from '@src/utils/fetch-utils';
import { DigitalAuditComment, ListCommentsResult } from './comments-constants';

export const listComments = async (url: string): Promise<DigitalAuditComment[]> => {
  const res = await DigitalAuditLambdaFetch(
    `/digital-audit/comments?url=${encodeURIComponent(url)}`,
    { method: 'GET' }
  );
  const { comments } = await awaitJSON<ListCommentsResult>(res);
  return comments;
};

/** The server derives the domain from `url` and stamps the author from the session. */
export const createComment = async (
  url: string,
  anchor: string,
  body: string
): Promise<DigitalAuditComment> => {
  const res = await DigitalAuditLambdaFetch('/digital-audit/comments', {
    method: 'POST',
    body: { url, anchor, body }
  });
  const { comment } = await awaitJSON<{ comment: DigitalAuditComment }>(res);
  return comment;
};
